import React, { Component } from "react";
import { Grid, Header, Segment, Image } from "semantic-ui-react";
import { connect } from "react-redux";

import FormsLogin from "../../component/forms/login";
import FormsLoginOtp from "../../component/forms/login/otp";
import { doLogin } from "../../actions";

import AppLogo from "../../component/logo";
class LoginForm extends Component {
  // The pending OTP challenge is kept here rather than in Redux on purpose:
  // the whole store is persisted to localStorage, and pendingToken is a live
  // second-factor credential that should not outlive the tab.
  state = {
    step: "credentials",
    pendingToken: null,
    otpPrefix: "",
    maskedEmail: "",
    notice: "",
  };

  componentDidMount() {
    if (this.props.user) {
      this.props.history.push("/chatapp");
    }
  }
  componentDidUpdate() {
    if (this.props.user) {
      this.props.history.push("/chatapp");
    }
  }

  handleOtpRequired = (data) => {
    this.setState({
      step: "otp",
      pendingToken: data.pendingToken,
      otpPrefix: data.otpPrefix,
      maskedEmail: data.maskedEmail,
      notice: "",
    });
  };

  // Called when the challenge can no longer be completed - attempts exhausted,
  // session expired, or the admin backing out deliberately.
  handleRestart = (notice) => {
    this.setState({
      step: "credentials",
      pendingToken: null,
      otpPrefix: "",
      maskedEmail: "",
      notice: notice || "",
    });
  };

  // A resend may return a different prefix, so follow the latest response.
  handleResent = (data) => {
    if (data && data.otpPrefix) {
      this.setState({ otpPrefix: data.otpPrefix });
    }
  };

  renderStep() {
    if (this.state.step === "otp") {
      return (
        <FormsLoginOtp
          pendingToken={this.state.pendingToken}
          otpPrefix={this.state.otpPrefix}
          maskedEmail={this.state.maskedEmail}
          onRestart={this.handleRestart}
          onResent={this.handleResent}
        />
      );
    }
    return (
      <FormsLogin
        doLogin={this.props.doLogin}
        history={this.props.history}
        notice={this.state.notice}
        onOtpRequired={this.handleOtpRequired}
      />
    );
  }

  render() {
    const isOtpStep = this.state.step === "otp";
    return (
      <div className="login-form">
        <Grid
          textAlign="center"
          style={{ height: "100%" }}
          verticalAlign="middle">
          <Grid.Column style={{ maxWidth: 450 }}>
            <Header as="h1" textAlign="center">
              <Image
                src="https://mplify.mhcasia.net/mhc_logo.jpg"
                size="huge"
              />
            </Header>
            <Header as="h2" textAlign="center">
              {isOtpStep ? "Verify your login" : "Log-in to your account"}
            </Header>
            <Segment stacked>{this.renderStep()}</Segment>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.data,
  };
};

export default connect(mapStateToProps, {
  doLogin,
})(LoginForm);
